import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { DateTableColumn } from 'src/app/core/models/date-table-column';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { WarehousingAbnormalService } from '../../../services/warehousing-abnormal.service';

@Component({
  selector: 'laas-warehousing-abnormal-history',
  templateUrl: './warehousing-abnormal-history.component.html',
  styleUrls: ['./warehousing-abnormal-history.component.scss']
})
export class WarehousingAbnormalHistoryComponent extends SessionBaseComponent implements OnInit {

  @Input() params: any;
  @Output() visibleChange: EventEmitter<any>;
  isVisible: boolean;

  abnormalTypeOptions: any;
  warehousingHeaderHistoryColumns: DateTableColumn[];
  warehousingHeaderHistoryResults: any[] = [];
  isLoading: boolean = false;

  @Input() get visible(): any {
    return this.isVisible;
  }

  set visible(value: any) {
    this.isVisible = value;
  }

  constructor(
    injector: Injector,
    private warehousingAbnormalService: WarehousingAbnormalService
  ) {
    super(injector);
    this.warehousingHeaderHistoryColumns = [
      { field: 'createUser', header: 'WarehousingAbnormal.Column.CreateUser', sort: false },
      { field: 'notifyDt', header: 'WarehousingAbnormal.Column.NotifyDt', sort: false },
      { field: 'handleDt', header: 'WarehousingAbnormal.Column.HandleDt', sort: false },
      { field: 'updateUser', header: 'WarehousingAbnormal.Column.HandleUser', sort: false },
      { field: 'abnormalType', header: 'WarehousingAbnormal.Form.AbnormalType', sort: false },
      { field: 'pcsrReason', header: 'WarehousingAbnormal.Column.PcsrReason', sort: false },
      { field: 'pcsrRemark', header: 'WarehousingAbnormal.Column.PcsrRemark', sort: false },
    ];
    this.isVisible = false;
    this.visibleChange = new EventEmitter<any>();
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    console.log(`init-params= ${JSON.stringify(this.params)}`);
    this.abnormalTypeOptions = this.params.abnormalTypeOptions;
    this.searchWarehousingAbnormal(this.params.whNo);
  }

  searchWarehousingAbnormal(whNo: string): void {
    this.isLoading = true;
    this.loader.show();
    this.warehousingAbnormalService.searchWarehousingAbnormalHistory(whNo).subscribe({
      next: (data: any[]) => {
        /* 成功取得資料 */
        this.warehousingHeaderHistoryResults = data;
      },
      error: (error: any) => {
        /* 錯誤處理 */
        this.warehousingHeaderHistoryResults = [];
        this.toastErrorMessage(error.error);
        this.loader.hide();
      },
      complete: () => {
        this.isLoading = false;
        this.loader.hide();
      }
    });
  }

  dialogVisibleChange(event: any): void {
    this.visibleChange.emit(event);
  }

}
